const ArrowDown03Icon = /*#__PURE__*/ [
  ["path", { d: "M6 20L18 20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 16V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 12C16 12 13.054 16 12 16C10.9459 16 8 12 8 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { ArrowDown03Icon as default };
//# sourceMappingURL=ArrowDown03Icon.js.map
